<div class="filter-tracks mb-4" #header>
  <rk-page-title [title]="'PLAYLIST.ADD_TRACKS.TITLE' | translate"></rk-page-title>
  <rk-search-bar type="full" (inputted)="onChangeSearch($event)"></rk-search-bar>
  <rk-box-filter
    [selectedBox]="selectedBox.value"
    (selectBox)="selectBox($event)"
  ></rk-box-filter>
</div>
<div
  class="tracks flex flex-1 flex-col -mb-5 -mr-3 cdk-custom-container"
  [style.height.px]="getListHeight()"
  *ngIf="(tracks$ | async).length; else searchEmpty"
>
  <cdk-virtual-scroll-viewport
    class="flex-1"
    itemSize="56"
    minBufferPx="800"
    maxBufferPx="1000"
  >
    <div
      class="track flex items-center relative bg-white h-15 pr-2 mb-4 -mx-2 rounded shadow-base"
      *cdkVirtualFor="let track of tracks$ | async; let i = index; templateCacheSize: 60"
      (click)="isPlaylistForm ? addTrackToPlaylist(track) : addTrackToGeneration(track)"
    >
      <img [src]="track.cover" alt="" class="size-15 mr-4 rounded" />
      <div class="flex flex-col mr-3 overflow-hidden whitespace-nowrap">
        <div class="track-title text-base font-bold">{{ track.title }}</div>
        <div class="track-artist text-gray-darkest">{{ track.artist }}</div>
      </div>
      <div class="ml-auto">
        {{ track.duration ? (track.duration | timeFormat) : '' }}
      </div>
    </div>
  </cdk-virtual-scroll-viewport>
</div>
<ng-template #searchEmpty>
  <div class="search-empty">
    <img src="/assets/search-empty.svg" alt="" />
    <div>
      {{ 'MEDIA.TABLE.SEARCH_EMPTY' | translate: { search: searchSubject.getValue() } }}
    </div>
  </div>
</ng-template>
